import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { EquipmentState } from '../types';
import { equipmentState } from './equipmentState';

export const equipmentSlice = createSlice({
  name: 'equipment',
  initialState: equipmentState,
  reducers: {
    setEquipments: (
      state,
      action: PayloadAction<EquipmentState['Equipments']>,
    ) => {
      state.Equipments = action.payload;
    },
    setTerminals: (
      state,
      action: PayloadAction<EquipmentState['Terminals']>,
    ) => {
      state.Terminals = action.payload;
    },
    setLimit: (state, action: PayloadAction<EquipmentState['limit']>) => {
      state.limit = action.payload;
    },
    setPageIndex: (
      state,
      action: PayloadAction<EquipmentState['pageIndex']>,
    ) => {
      state.pageIndex = action.payload;
    },
    setTotalRecordCount: (
      state,
      action: PayloadAction<EquipmentState['totalRecordCount']>,
    ) => {
      state.totalRecordCount = action.payload;
    },
    setName(state, action: PayloadAction<EquipmentState['name']>) {
      state.name = action.payload;
    },
    setTerminalId(state, action: PayloadAction<EquipmentState['terminalId']>) {
      state.terminalId = action.payload;
    },
    setAssetType(state, action: PayloadAction<EquipmentState['assetType']>) {
      state.assetType = action.payload;
    },
    setCreateUpdateEquipmentModal: (
      state,
      action: PayloadAction<EquipmentState['createUpdateEquipmentModal']>,
    ) => {
      state.createUpdateEquipmentModal = action.payload;
    },
    setSelectedEquipmentId: (
      state,
      action: PayloadAction<EquipmentState['selectedEquipmentId']>,
    ) => {
      state.selectedEquipmentId = action.payload;
    },
    setVisibilitySets: (
      state,
      action: PayloadAction<EquipmentState['visibilitySets']>,
    ) => {
      state.visibilitySets = action.payload;
    },
    setDvirForms: (
      state,
      action: PayloadAction<EquipmentState['dvirForms']>,
    ) => {
      state.dvirForms = action.payload;
    },
    setProducts: (state, action: PayloadAction<EquipmentState['products']>) => {
      state.products = action.payload;
    },
    setAccountProperties: (
      state,
      action: PayloadAction<EquipmentState['accountProperties']>,
    ) => {
      state.accountProperties = action.payload;
    },
    setExportModal: (
      state,
      action: PayloadAction<EquipmentState['exportModal']>,
    ) => {
      state.exportModal = action.payload;
    },
    setCsvExportModalOpen: (
      state,
      action: PayloadAction<EquipmentState['csvExportModalOpen']>,
    ) => {
      state.csvExportModalOpen = action.payload;
    },
    setVisibilitySetsModalOpen: (
      state,
      action: PayloadAction<EquipmentState['visibilitySetsModalOpen']>,
    ) => {
      state.visibilitySetsModalOpen = action.payload;
    },
    setEldEnabled: (
      state,
      action: PayloadAction<EquipmentState['eldEnabled']>,
    ) => {
      state.eldEnabled = action.payload;
    },
    setIsUseGpsOdometerEnabled: (
      state,
      action: PayloadAction<EquipmentState['isUseGpsOdometerEnabled']>,
    ) => {
      state.isUseGpsOdometerEnabled = action.payload;
    },
    setIsUseManualEngineHoursEnabled: (
      state,
      action: PayloadAction<EquipmentState['isUseManualEngineHoursEnabled']>,
    ) => {
      state.isUseManualEngineHoursEnabled = action.payload;
    },
    setIsDuplicateVinEnabled: (
      state,
      action: PayloadAction<EquipmentState['isDuplicateVinEnabled']>,
    ) => {
      state.isDuplicateVinEnabled = action.payload;
    },
    setCanActivateCalAmpDevice: (
      state,
      action: PayloadAction<EquipmentState['canActivateCalAmpDevice']>,
    ) => {
      state.canActivateCalAmpDevice = action.payload;
    },
    setShowMonthlyChanges: (
      state,
      action: PayloadAction<EquipmentState['showMonthlyChanges']>,
    ) => {
      state.showMonthlyChanges = action.payload;
    },
    setCreateUpdateModal: (
      state,
      action: PayloadAction<EquipmentState['createUpdateModal']>,
    ) => {
      state.createUpdateModal = action.payload;
    },
    setResetData: () => {
      return equipmentState;
    },
  },
});

export const { actions: equipmentActions } = equipmentSlice;

const SelectEquipment = (state: RootState) => state.equipment;

export const SelectEquipmentList = createSelector(
  SelectEquipment,
  equipment => equipment.Equipments,
);

export const SelectTerminals = createSelector(
  SelectEquipment,
  equipment => equipment.Terminals,
);

export const SelectLimit = createSelector(
  SelectEquipment,
  equipment => equipment.limit,
);

export const SelectPageIndex = createSelector(
  SelectEquipment,
  equipment => equipment.pageIndex,
);

export const SelectTotalRecordCount = createSelector(
  SelectEquipment,
  equipment => equipment.totalRecordCount,
);

export const SelectName = createSelector(
  SelectEquipment,
  equipment => equipment.name,
);

export const SelectTerminalId = createSelector(
  SelectEquipment,
  equipment => equipment.terminalId,
);

export const SelectAssetType = createSelector(
  SelectEquipment,
  equipment => equipment.assetType,
);

export const SelectCreateUpdateEquipmentModal = createSelector(
  SelectEquipment,
  equipment => equipment.createUpdateEquipmentModal,
);

export const SelectSelectedEquipmentId = createSelector(
  SelectEquipment,
  equipment => equipment.selectedEquipmentId,
);

export const SelectVisibilitySets = createSelector(
  SelectEquipment,
  equipment => equipment.visibilitySets,
);

export const SelectDvirForms = createSelector(
  SelectEquipment,
  equipment => equipment.dvirForms,
);

export const SelectProducts = createSelector(
  SelectEquipment,
  equipment => equipment.products,
);

export const SelectAccountProperties = createSelector(
  SelectEquipment,
  equipment => equipment.accountProperties,
);

export const SelectExportModal = createSelector(
  SelectEquipment,
  equipment => equipment.exportModal,
);

export const SelectCsvExportModalOpen = createSelector(
  SelectEquipment,
  equipment => equipment.csvExportModalOpen,
);

export const SelectVisibilitySetsModalOpen = createSelector(
  SelectEquipment,
  equipment => equipment.visibilitySetsModalOpen,
);

export const SelectEldEnabled = createSelector(
  SelectEquipment,
  equipment => equipment.eldEnabled,
);

export const SelectUseOdoMeterEnabled = createSelector(
  SelectEquipment,
  equipment => equipment.isUseGpsOdometerEnabled,
);

export const SelectUseManualEngineHoursEnabled = createSelector(
  SelectEquipment,
  equipment => equipment.isUseManualEngineHoursEnabled,
);

export const SelectDuplicateVinEnabled = createSelector(
  SelectEquipment,
  equipment => equipment.isDuplicateVinEnabled,
);

export const SelectCanActivateCalAmpDevice = createSelector(
  SelectEquipment,
  equipment => equipment.canActivateCalAmpDevice,
);

export const SelectShowMonthlyChanges = createSelector(
  SelectEquipment,
  equipment => equipment.showMonthlyChanges,
);

export const SelectCreateUpdateModal = createSelector(
  SelectEquipment,
  equipment => equipment.createUpdateModal,
);

export default equipmentSlice.reducer;
